import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Header from "./components/header";
import LeavePolicySettings from "./components/LeavePolicy";
import Configuration from "./configuration";
import { useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";

const LeaveSettingSection = () => {
    const [topTab, setTopTab] = useState("Configurations");
    return (
        <DashboardLayout>
        <DashboardNavbar/>
        <Header topTab={topTab} setTopTab={setTopTab} />
        <Configuration />
        {/* <LeavePolicySettings /> */}
        </DashboardLayout>
    );
};

export default LeaveSettingSection;